import { forwardRef } from 'react';

import { Button, ButtonVariant } from '@ui/components/base/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@ui/components/base/tooltip';

interface CustomIconButtonProps extends React.ComponentProps<typeof Button> {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  tooltipText?: string;
  iconClassName?: string;
}

const CustomIconButton = forwardRef<HTMLButtonElement, CustomIconButtonProps>(
  (
    {
      icon: Icon,
      tooltipText,
      iconClassName = 'size-4',
      size = 'icon-sm',
      variant = ButtonVariant.GHOST,
      className,
      ...rest
    },
    ref
  ) => {
    const button = (
      <Button ref={ref} variant={variant} size={size} className={className} {...rest}>
        <Icon className={iconClassName} />
      </Button>
    );

    if (!tooltipText) {
      return button;
    }

    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger render={<span />}>{button}</TooltipTrigger>
          <TooltipContent side="bottom">{tooltipText}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
);
CustomIconButton.displayName = 'CustomIconButton';

export { CustomIconButton };
export type { CustomIconButtonProps };
